//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TabelaGenerica from '../../../../shared-components/generico/TabelaGenerica';
import mdChipsAutocomplete from '../../../../shared-components/chipsautocomplete/mdChipsAutocomplete';

import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  extends: TabelaGenerica,
  data() {
    return {
      chipsTipoInvestimento: [],
    };
  },
  props: {
    fetchFunction: Function,
    prepareResponseData: Function,
  },
  components: {
    mdChipsAutocomplete,
  },
  computed: {
    ...generateComputed('Tipo Orc', [
      'canAccessCRUD',
    ]),
    tipoOrcamentoFilteredList() {
      return this.filteredList.map((elemento) => {
        if (typeof elemento.tiposInvestimento !== 'string') {
          return elemento;
        }

        const row = Object.assign({}, elemento);

        const tiposInvestimento = this.stringToArray(elemento.tiposInvestimento);

        row.tiposInvestimento = tiposInvestimento;
        return row;
      });
    },
  },
  methods: {
    addTipoInvestimentoChip(value) {
      this.currentEditItem.tiposInvestimento = value;
    },
    extractTipoInvestimentoName(row) {
      return row.tiposInvestimento.map(el => el.nome).join(', ');
    },
    stringToArray(string) {
      return string.split(',').map((cat) => {
        const tiposInvestimentoStr = cat.split(':');
        return {
          id: parseInt(tiposInvestimentoStr[0], 10),
          nome: tiposInvestimentoStr[1],
        };
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/tipo-orcamento/TipoOrcamentoTabela.vue?vue&type=script&lang=js&